import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DynamicHooksModule } from 'ngx-dynamic-hooks';

@Component({
  selector: 'app-dynamic-content',
  templateUrl: './dynamic-content.component.html',
  styleUrls: ['./dynamic-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DynamicHooksModule]
})
export class DynamicContentComponent {
  @Input() content: string;
}
